import { render, staticRenderFns } from "./CompanyAddressModal.vue?vue&type=template&id=45eb6322"
import script from "./CompanyAddressModal.vue?vue&type=script&lang=js"
export * from "./CompanyAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports